import { capitalize } from "@msuite/utils/strings";
import clsx from "clsx";
import type { HorizontalBarProps } from "./horizontal-bar";

export function HorizontalLegendItem({ name, value, formatter, index }: HorizontalBarProps) {
	/** Render */
	return (
		<div className="gap-1 h-stack">
			<div
				className={clsx("bg-linear-0 rounded-xs w-2 aspect-square bg-accent-500")}
				style={{ filter: `hue-rotate(${index * 30}deg)` }}
			/>
			<p className="text-xs">
				{capitalize(name)}: {formatter ? formatter(value) : value}
			</p>
		</div>
	);
}
